/* ============ Featured stories slider ============ */
(function () {
  var root = $('#feature');
  if (!root) return;

  var slides = $$('.slide', root);
  var dots = $$('[data-go]', root);
  var DUR = 8000;
  root.style.setProperty('--dur', DUR + 'ms');

  var i = 0, timer = null, paused = false;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function go(n) {
    if (n === i || !slides.length) return;
    var prev = slides[i];
    prev.classList.remove('is-active');
    prev.classList.add('is-leaving');
    prev.setAttribute('aria-hidden', 'true');
    setTimeout(function () { prev.classList.remove('is-leaving'); }, 1400);

    i = (n + slides.length) % slides.length;
    slides[i].classList.add('is-active');
    slides[i].removeAttribute('aria-hidden');

    dots.forEach(function (d, k) {
      d.setAttribute('aria-current', k === i ? 'true' : 'false');
      var bar = d.querySelector('i');
      if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
    });

    var v = slides[i].querySelector('video');
    if (v) { v.currentTime = 0; v.play().catch(function () {}); }

    schedule();
  }

  function schedule() {
    clearTimeout(timer);
    if (!paused && !reduce && slides.length > 1) timer = setTimeout(function () { go(i + 1); }, DUR);
  }

  root.addEventListener('click', function (e) {
    var d = e.target.closest('[data-go]');
    if (d) go(+d.dataset.go);
    var s = e.target.closest('[data-step]');
    if (s) go(i + +s.dataset.step);
  });

  root.addEventListener('mouseenter', function () { paused = true; root.classList.add('is-paused'); clearTimeout(timer); });
  root.addEventListener('mouseleave', function () { paused = false; root.classList.remove('is-paused'); schedule(); });

  var x0 = null;
  root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  root.addEventListener('touchend', function (e) {
    if (x0 == null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1));
    x0 = null;
  });

  document.addEventListener('keydown', function (e) {
    if (e.target.closest('input, textarea')) return;
    if (e.key === 'ArrowRight') go(i + 1);
    if (e.key === 'ArrowLeft') go(i - 1);
  });

  dots.forEach(function (d, k) { d.setAttribute('aria-current', k === 0 ? 'true' : 'false'); });

  if (window.rootedIntroPending && slides[0]) {
    /* Hold the first slide until the intro lifts, so its soft-focus entrance is seen */
    slides[0].classList.remove('is-active');
    slides[0].style.visibility = 'visible';
    window.rootedAfterIntro = function () {
      slides[0].style.visibility = '';
      slides[0].classList.add('is-active');
      var bar0 = dots[0] && dots[0].querySelector('i');
      if (bar0) { bar0.style.animation = 'none'; void bar0.offsetWidth; bar0.style.animation = ''; }
      schedule();
    };
  } else {
    schedule();
  }
})();
